module.exports = __webpack_public_path__ + "static/netflix_395x404-e24a57f5ecbd76980169edf1bc1b4ee1.webp";